import { Link } from 'react-router-dom';

import ErrorPage from '@/components/errors/ErrorPage';
import SingleCardTemplate from '@/components/layouts/SingleCardTemplate';
import Button from '@/components/ui/buttons/Button';
import { pageTitles } from '@/constants/pageTitles';
import useAuthentication from '@/hooks/common/useAuthentication';

import styles from './ResetPasswordCompletedPage.module.scss';

interface Props {
  completed: boolean;
}

const ResetPasswordCompletedPage: React.FC<Props> = ({ completed }) => {
  const { isLoggedIn } = useAuthentication();

  if (!completed) return <ErrorPage type="not_found" />;

  const buttonLabel = isLoggedIn ? 'マイページへ' : 'ログインページへ';
  const buttonUrl = isLoggedIn ? '/mypage/profile' : '/login';

  return (
    <SingleCardTemplate title={pageTitles.passwordReset}>
      <div className={styles.wrapper}>
        <div className={styles.inner}>
          <h3 className={styles.title}>パスワードの再設定が完了しました</h3>

          <div className={styles.description}>
            「{buttonLabel}」ボタンより引き続き
            <br />
            スタディサプリをご利用ください。
          </div>

          <Button
            tag={Link}
            to={buttonUrl}
            color="primary"
            className={styles.button}
          >
            {buttonLabel}
          </Button>
        </div>
      </div>
    </SingleCardTemplate>
  );
};

export default ResetPasswordCompletedPage;
